import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RedirectScene extends Component {

  componentWillReceiveProps (nextProps) {
    if (nextProps.isLoaded) {
      this.initRedirect()
    }
  }

  redirect = () => {
    if (window.removeRootElt) {
      window.removeRootElt()
    } else {
      const pathname = document.location.pathname
      history.pushState({}, 'redirectFromPage', `${pathname}?1`)
      window.location.href = this.props.redirectUrl
    }
  }

  initRedirect () {
    // check if we are inside a shopify site
    const delay = window.shopName ? 100 : 1000
    setTimeout(this.redirect, delay)
  }

  render () {
    return (
      <div className='swiper-slide slide'>
        <div style={{visibility: `${this.props.isLoaded ? 'visible' : 'hidden'}`, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '3rem', height: '100%'}}>
          Redirecting to {this.props.redirectUrl}
        </div>
      </div>
    )
  }
}

RedirectScene.propTypes = {
  redirectUrl: PropTypes.string,
  isLoaded: PropTypes.bool
}

export default RedirectScene



// WEBPACK FOOTER //
// ./src/templates/outSide/components/scenes/RedirectScene.js